import { useState } from "react";
import { Form, Formik } from "formik";
import styled from "styled-components";
import * as Yup from "yup";
import TextInputField from "../../components/formik/TextInputField";
import SelectDropdownField from "../../components/formik/SelectDropdownField";
import { Button } from "../../components/Buttons";

// Styled Components
const Container = styled.div<{ showFilter: boolean }>`
  border: 1px solid #eaeaea;
  border-radius: 10px;
  padding: 30px 20px;
  flex: 1 1 0;
  margin-top: 20px;
`;

const FieldWrapper = styled.div`
  margin-bottom: 10px;
`;

const ActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
`;

const FilterForm = ({ showFilter }: any) => {
  const FormInitialValues = {
    name: "",
    categories: "",
    network: "",
    badge: "",
    ecoCategories: "",
    impactScore: "",
  };

  const [initialValues, setInitialValues] = useState(FormInitialValues);

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
  });

  const handleSubmit = () => {};

  return (
    <Container showFilter={showFilter}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(props: any) => {
          console.log("props", props);
          return (
            <Form>
              <FieldWrapper>
                <TextInputField
                  label="Filter by Name"
                  name="name"
                  type="text"
                  placeholder="Enter name"
                />
              </FieldWrapper>
              <FieldWrapper>
                <SelectDropdownField
                  label="General Categories"
                  name="categories"
                  options={[{ value: "option1", label: "Option 1" }]}
                  placeholder="Select categories"
                />
              </FieldWrapper>
              <FieldWrapper>
                <SelectDropdownField
                  label="Blockchain Network"
                  name="network"
                  options={[{ value: "option1", label: "Option 1" }]}
                  placeholder="Select network"
                />
              </FieldWrapper>
              <FieldWrapper>
                <SelectDropdownField
                  label="Filter by Badge"
                  name="badge"
                  options={[{ value: "option1", label: "Option 1" }]}
                  placeholder="Select badge"
                />
              </FieldWrapper>
              <FieldWrapper>
                <SelectDropdownField
                  label="Eco Categories"
                  name="ecoCategories"
                  options={[{ value: "option1", label: "Option 1" }]}
                  placeholder="Select category"
                />
              </FieldWrapper>
              <FieldWrapper>
                <SelectDropdownField
                  label="Rank by Impact Score"
                  name="impactScore"
                  options={[{ value: "option1", label: "Option 1" }]}
                  placeholder="Select score"
                />
              </FieldWrapper>
              <ActionsWrapper>
                <Button variant="light">Clear</Button>
                <Button variant="primary" type="submit">
                  Apply
                </Button>
              </ActionsWrapper>
            </Form>
          );
        }}
      </Formik>
    </Container>
  );
};

export default FilterForm;
